<template>
    <div class="container">
        <div class="success-title">
            <van-icon name="checked" color="#0256ff" :size="32" />
            <span class="success-title-text">绑定成功</span>
        </div>
        <div class="success-content">
            手机号已绑定成功，现在您可以正常收到智珠侠的推送消息了。感谢您的支持与信任，我们会继续努力为您提供更好的服务。
        </div>

        <div class="fixed-bottom-container">
            <button class="btn btn-primary" @click="backToMiniProgram">关闭页面</button>
            <!-- <button class="btn btn-default" @click="backToMiniProgram">返回小程序</button> -->
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    beforeMount() {

    },
    methods: {
        backToMiniProgram() {
            try{
                window.WeixinJSBridge.call('closeWindow')
            }
            catch (e) {
                console.error('Error closing window:', e)
                window.close()
            }
        }
    },
}
</script>

<style lang="less" scoped>
.container {
    background: linear-gradient(180deg, rgba(14, 107, 254, 0.25) 0%, rgba(14, 107, 254, 0) 100%);
    padding-top: 24px;
}

.success-title {
    display: flex;
    justify-content: center;
    align-items: center;

    .success-title-text {
        margin-left: 10px;
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }
}

.success-content {
    box-sizing: border-box;
    padding: 24px;
    font-size: 16px;
    color: #666;
    text-align: left;
}

.fixed-bottom-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 24px;
}

.btn {
    width: 100%;
    height: 48px;
    border-radius: 24px;
    font-size: 16px;
    text-align: center;
    line-height: 48px;
    margin-bottom: 16px;
    border: none;
}

.btn-primary {
    background: linear-gradient(90deg, #1890FF 0%, #0256FF 100%);
    color: #fff;
}

.btn-default {
    background-color: #f5f5f5;
    color: #333;
}
</style>